import { queryOptions } from '@tanstack/react-query'
import { minutesToMilliseconds } from 'date-fns/minutesToMilliseconds'
import { fetchRetailerETAs } from '@/features/shop/services/DeliveryWindows/fetchers'
import { type RetailerETARequestParams } from '@/features/shop/services/DeliveryWindows/types'

export const retailerETAQueryOptions = (params: RetailerETARequestParams) =>
  queryOptions({
    queryKey: ['retailer etas', params] as const,
    queryFn: fetchRetailerETAs,
    staleTime: minutesToMilliseconds(10),
  })
